import { render, staticRenderFns } from "./newProjectDialog.vue?vue&type=template&id=241d94ba&scoped=true"
import script from "./newProjectDialog.vue?vue&type=script&lang=ts"
export * from "./newProjectDialog.vue?vue&type=script&lang=ts"
import style0 from "./newProjectDialog.vue?vue&type=style&index=0&id=241d94ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241d94ba",
  null
  
)

export default component.exports